<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputSelect
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        :options="arrangedByOptions"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../../helpers/questionLoadHelpers";
import { estatePlanningSurveyOptions } from "../../../../options/estatePlanningSurveyOptions";

import QuestionBase from "../../../../QuestionBase";
import InputSelect from "../../../../inputs/InputSelect";

export default {
  name: 'LifeInsuranceArrangedBy',
  mixins: [questionLoadHelpers, estatePlanningSurveyOptions],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'Who organised your current protection / insurance arrangements?',
        subTitle:  null,
        tip: null
      },
      db: {
        saveLocation: 'estate_planning_survey_save',
        saveField: 'life_insurance_arranged_details'
      },
      args: {
        placeholder: 'Select option...',
        label: null,
        skippable: false,
        required: true,
        inputClass: 'field-50'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false
    }
  }
}
</script>